import { EmptyState } from '@app/components/base/EmptyState';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import { defineMessage, FormattedMessage } from 'react-intl';

const ltxMatchesReportEmptyHelp = defineMessage({
  id: 'audit.ltxMatchesReport.emptyState.help',
  defaultMessage:
    'Compara los logs LTX importados con los matches del sistema para el día seleccionado. Permite verificar qué emisiones del log externo fueron confirmadas y cuáles no.',
});

/**
 * Placeholder shown before the first LTX matches report run, explaining what the report calculates.
 */
export function LtxMatchesReportEmptyState() {
  return (
    <EmptyState
      icon={FactCheckOutlinedIcon}
      message={false}
      help={<FormattedMessage {...ltxMatchesReportEmptyHelp} />}
    />
  );
}
